import { render, staticRenderFns } from "./detailMessageTopic.vue?vue&type=template&id=ee4f743a&"
import script from "./detailMessageTopic.vue?vue&type=script&lang=js&"
export * from "./detailMessageTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports